import React from 'react'

import './styles.scss'

const bc = 'button-link'

interface Interface {
  text: string
  onClick: () => void
}

const ButtonLink: React.FC<Interface> = ({ text, onClick }) => (
  <span className={bc} onClick={onClick}>
    {text}
  </span>
)

export default ButtonLink
